<template>
  <div
    class="search-box"
    v-if="columns.length > 0"
    :style="{ backgroundColor: backgroundColor }"
  >
    <el-form
      :inline="true"
      :model="formInline"
      :rules="rules"
      ref="commonForm"
      :labelWidth="labelWidth"
      class="demo-form-inline"
      :disabled="disabled"
    >
    <QS-search maxLine="2" ref="BLM-search">
        <slot name="header"></slot>
        <template v-for="(item, index) in columns">
          <!-- 类型合集 -->
          <template v-if="!filterKeys.includes(item.type)">
            <el-form-item
              :class="{
                alone: getValue(item, 'alone', false),
                zflex: getValue(item, 'jumpPage', false),
              }"
              :key="index"
              :prop="item.key"
              :label="item.label + colon"
              v-show="!item.showFn || item.showFn(formInline)"
              :ref="getValue(item, 'ref')"
            >
              <!-- 提示组件 -->
              <template v-if="item.tooTip">
                <too-tip :item="item"></too-tip>
              </template>

              <!-- Input类型 -->
              <template v-if="item.type === 'input'">
                <input-type :change="item.options.change" :item="item" :formInline="formInline"></input-type>
                <QSButtton
                  v-if="getValue(item, 'btnConfig')"
                  :options="getValue(item, 'btnConfig').attrs"
                  :text="getValue(item, 'btnConfig').text"
                  :clickFn="getValue(item, 'btnConfig').clickFn"
                ></QSButtton>
              </template>

              <!-- textarea类型 -->
              <template v-if="item.type === 'textarea'">
                <text-area-type
                  :item="item"
                  :formInline="formInline"
                ></text-area-type>
              </template>

              <!-- tel, number, lngLat, money, float, customInput类型合集-->
              <template v-else-if="customTypeList.includes(item.type)">
                <!-- tel, number, lngLat, money, float类型 -->
                <tel-type
                  v-if="item.type !== 'customInput'"
                  :item="item"
                  :formInline="formInline"
                ></tel-type>
                <!-- customInput类型 -->
                <custom-input-type
                  v-else
                  :item="item"
                  :formInline="formInline"
                ></custom-input-type>
              </template>

              <!-- Select类型 -->
              <template v-else-if="item.type === 'select'">
                <select-type
                  :item="item"
                  :formInline="formInline"
                ></select-type>
                <link-button
                  v-if="getValue(item, 'jumpPage', null)&&(!getValue(item, 'jumpPage').isHidden)"
                  :item="item"
                  :clickFn="getValue(item, 'jumpPage').fn"
                  :text="getValue(item, 'jumpPage').text"
                ></link-button>
                <QSButtton
                  v-if="getValue(item, 'btnConfig')"
                  :options="getValue(item, 'btnConfig').attrs"
                  :text="getValue(item, 'btnConfig').text"
                  :clickFn="getValue(item, 'btnConfig').clickFn"
                ></QSButtton>
              </template>

              <!-- DatePicker类型 -->
              <template
                v-else-if="
                  item.type === 'dateMonthPick' ||
                  item.type === 'datetime' ||
                  item.type === 'datePick'
                "
              >
                <date-picker-type
                  :item="item"
                  :formInline="formInline"
                ></date-picker-type>
              </template>

              <!-- CascaderType类型 -->
              <template v-else-if="item.type === 'cascader'">
                <cascader-type
                  :item="item"
                  :formInline="formInline"
                ></cascader-type>
              </template>

              <!-- Text类型 -->
              <div v-else-if="item.type === 'text'">
                {{ formInline[item.key] }}
              </div>
              <!-- 底部文字模块 -->
              <div
                class="item-bottom-txt"
                v-if="getValue(item, 'bottomText')"
                v-html="getValue(item, 'bottomText')"
              ></div>
            </el-form-item>
          </template>

          <!-- 区域级联类型 -->
          <template v-else-if="item.type === 'areaLinkage'">
            <area-linkage
              :key="index"
              ref="areaLinkage"
              class="alone"
              :column="item.options && item.options.column"
              :labelWidth="
                item.options && item.options.labelWidth
                  ? item.options.labelWidth
                  : 130
              "
              :codes="defaultValue.areaLinkage"
              @change="areaChange"
              :getAreaList="areaChangeFn"
              :hasColon="hasColon"
            ></area-linkage>
          </template>
          <!-- 上传组件类型 -->
          <template v-else-if="item.type === 'upload'">
            <!-- required -->
            <el-form-item
              :key="index"
              :label="item.label + colon"
              :class="{ alone: item.alone }"
            >
              <!-- fileList获取formInline加上列表的key -->
              <upload-common
                v-bind="item.options"
                :fileList="formInline[item.key]"
              ></upload-common>
            </el-form-item>
          </template>

          <!-- 开始结束组件类型-->
          <template v-else-if="item.type === 'startEnd'">
            <start-end-type
              :key="index"
              :item="item"
              :formInline="formInline"
            ></start-end-type>
          </template>
        </template>

        <slot name="default"></slot>
        <template slot="moreBtn">
        <el-form-item v-if="!hiddenBtn">
          <slot name="btn-before"></slot>
          <el-button type="primary" @click="onSubmit" :loading="loading">{{
            sureBtn
          }}</el-button>
          <el-button @click="onClean">{{ cleanBtn }}</el-button>
          <slot name="btn-after"></slot>
        </el-form-item>
        </template>
     </QS-search>
    </el-form>
  </div>
</template>

<script>
import TooTip from './tooTip'
import InputType from './components/inputType'
import TextAreaType from './components/textAreaType'
import TelType from './components/telType'
import SelectType from './components/selectType'
import CustomInputType from './components/customInputType'
import DatePickerType from './components/datePickerType.vue'
import CascaderType from './components/cascaderType'
import StartEndType from './components/startEndType'

// 特殊的组件自定义
import LinkButton from './components/linkButton'
import QSButtton from '@/components/CommonLayout/QSButton'

const floatLength = {
  lngLat: 6,
  money: 2,
  float: 1,
  startEnd: 2,
}
const customTypeList = [
  'tel',
  'number',
  'lngLat',
  'money',
  'float',
  'customInput',
]
export default {
  name: 'searchBox',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    rules: {
      type: Object,
      default: () => ({}),
    },
    // eslint-disable-next-line vue/no-unused-properties
    column: {
      type: Number,
      default: 3,
    },
    sureBtn: {
      type: String,
      default: '查询',
    },
    cleanBtn: {
      type: String,
      default: '重置',
    },
    defaultValue: {
      type: Object,
      default: () => ({}),
    },
    labelWidth: {
      type: String,
      default: '130px',
    },
    hiddenBtn: {
      type: Boolean,
      default: false,
    },
    areaChangeFn: {
      type: Function,
      default: () => ({}),
    },
    hasColon: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: 'rgb(247, 248, 250)',
    },
  },
  components: {
    TooTip,
    InputType,
    TextAreaType,
    TelType,
    CustomInputType,
    SelectType,
    DatePickerType,
    CascaderType,
    StartEndType,
    LinkButton,
    QSButtton,
  },
  provide() {
    return {
      // 默认最大长度
      defaultMaxLenght: this.defaultMaxLenght,
      // 是否显示：分割
      colon: this.colon,
      // 定制的类型列表
      customTypeList: this.customTypeList,
      // getValue函数
      getValue: this.getValue,
      // input默认展示文案
      placeholder: this.placeholder,
      // select默认展示文案
      selectPlaceholder: this.selectPlaceholder,
      // 自定义事件
      customInputHandle: this.customInputHandle,
      // 失焦事件
      telBlur: this.telBlur,
      // 替换非数字函数
      numberMax: this.numberMax,
      // selectChange函数
      changeSelect: this.changeSelect,
    }
  },
  data() {
    return {
      defaultMaxLenght: 50,
      disabled: false, // 当前整个form禁止输入
      filterKeys: ['areaLinkage', 'upload', 'startEnd'], // 用户判断哪些key值不走循环
      placeholder: '请输入',
      selectPlaceholder: '请选择',
      formInline: {},
      isHaveAreaLinkAge: false, // 是否含有区域级联组件
      areaCodes: {
        provinceCode: '',
        cityCode: '',
        countyCode: '',
      },
    }
  },
  computed: {
    colon() {
      return this.hasColon ? ':' : ''
    },
    customTypeList() {
      return customTypeList
    },
  },
  watch: {
    formInline: {
      handler(newValue) {
        this.$emit('monitoringVal', newValue)
      },
      deep: true,
    },
  },
  methods: {
    getValue(item, k2, defaultValue = '', k1 = 'options') {
      return (item && k1 && k2 && item[k1] && item[k1][k2]) || defaultValue
    },
    numberMax(item, maxValue) {
      if (item && item.options && item.options.type === 'number') {
        this.formInline[item.key] = this.formInline[item.key].replace(/\D/g, '')
        // 是数字类型并且有第二个参数第二参数是数字类型
        if (maxValue && typeof maxValue === 'number') {
          // 不能以0开头
          this.formInline[item.key] = this.formInline[item.key].replace(/^0{1,}/g, '')
          // 大于最大值取最大值
          this.formInline[item.key] = Number(this.formInline[item.key]) > maxValue ? String(maxValue) : this.formInline[item.key]
        }
      }
    },
    changeSelect(e, item) {
      if (item.options && item.options.change_s) {
        item.options.change_s(e)
      }
    },
    onSubmit() {
      let returnData = null
      this.$refs.commonForm.validate((valid) => {
        if (valid) {
          this.$emit('search', this.getValidKey())
          returnData = this.getValidKey()
        }
      })
      return returnData
    },
    telBlur(e, item, isBlur) {
      let value = ''
      if (e) {
        value = e.srcElement.value || e.target.value || ''
      }
      let val = ''
      if (item.type === 'tel' || item.type === 'number') {
        val = String(value).replace(/\D+/g, () => '')
      } else if (['lngLat', 'money', 'float', 'startEnd'].includes(item.type)) {
        let n = floatLength[item.type]
        if (item.type === 'float') {
          n = this.getValue(item, 'float', 1)
        }
        const reg = new RegExp(`([0-9]+)|(\\.[0-9]{0,${n}})`, 'g')
        const arr = String(value).match(reg)
        if (arr && arr.length) {
          val = arr[0] + (arr[1] || '')
        }
      }
      let max = this.getValue(item, 'max', 0)
      // 区间8位+2位小数
      if (item.type === 'startEnd') {
        max = '99999999.99'
      }
      if (max) {
        if (Number(val) > max) val = max
      }
      if (isBlur) {
        // 传过来的特殊的失焦事件
        if (this.getValue(item, 'blurFn')) {
          if (
            (typeof this.getValue(item, 'blurFn')).toUpperCase() === 'FUNCTION'
          ) {
            this.getValue(item, 'blurFn')(val, item)
          }
        }
        setTimeout(() => {
          if (item.type === 'startEnd') {
            this.$set(this.formInline, e.target.dataset.attr, val)
          } else {
            this.$set(this.formInline, item.key, val)
          }
        })
      } else if (item.type === 'startEnd') {
        this.$set(this.formInline, e.target.dataset.attr, val)
      } else {
        // 传过来的特殊的失焦事件
        if (this.getValue(item, 'changeFn')) {
          if (
            (typeof this.getValue(item, 'changeFn')).toUpperCase() ===
              'FUNCTION'
          ) {
            this.getValue(item, 'changeFn')(val, item)
          }
        }
        this.$set(this.formInline, item.key, val)
      }
    },
    onClean() {
      this.$refs.commonForm.resetFields()
      this.formInline = {}
      this.$refs.areaLinkage && this.$refs.areaLinkage[0].reset()
      this.$emit('btnReset')

      this.$nextTick(() => {
        this.initParams()
      })
    },
    // 初始化值
    // asyncValue必须为对象，并且对应到key
    initParams(asyncValue) {
      const params = {}
      // 异步去设置时
      if (asyncValue) {
        // eslint-disable-next-line vue/no-mutating-props
        this.defaultValue = asyncValue
      }
      for (const { type, key } of this.columns) {
        if (!this.filterKeys.includes(type)) {
          if (
            this.defaultValue &&
            (this.defaultValue[key] || this.defaultValue[key] === 0)
          ) {
            params[key] =
              this.defaultValue[key] || this.defaultValue[key] === 0
                ? this.defaultValue[key]
                : ''
          } else {
            params[key] = ''
          }
        } else {
          // 区域级联数据特殊处理
          if (type === 'areaLinkage') {
            if (this.defaultValue.areaLinkage) {
              Object.keys(this.areaCodes).forEach((codeKey) => {
                params[codeKey] = this.defaultValue.areaLinkage[codeKey]
              })
              this.$refs.areaLinkage && this.$refs.areaLinkage[0].init()
            } else {
              Object.keys(this.areaCodes).forEach((areaKey) => {
                params[areaKey] = ''
              })
            }
          }

          // 图片上传特殊处理
          if (type === 'upload') {
            if (
              this.defaultValue &&
              (this.defaultValue[key] || this.defaultValue[key] === 0)
            ) {
              params[key] = this.upLoadEchoImage(this.defaultValue[key])
            } else {
              params[key] = []
            }
          }
        }
      }
      this.formInline = params
    },
    getValidKey() {
      const result = {}
      for (const key in this.formInline) {
        result[key] = this.formInline[key]
      }
      return result
    },
    areaChange(codes) {
      const arr = Object.keys(this.areaCodes)
      this.formInline[arr[0]] = codes.province.code
      this.formInline[arr[1]] = codes.city.code
      this.formInline[arr[2]] = codes.county.code
    },
    // 根据后端返回数据回显图片上传
    upLoadEchoImage(data) {
      const _return = []
      if (data) {
        const _arr = data.split(',')
        _arr.forEach((item) => {
          _return.push({
            status: 'success',
            url: item,
            name: item.slice(item.lastIndexOf('/') + 1),
          })
        })
      }
      return _return
    },
    // 初始化区域级联组件的默认key值生成对应的对象
    initAreaLinkAgeDataByKey() {
      const _arr = this.columns.filter((item) => item.type === 'areaLinkage')
      if (_arr.length) {
        this.isHaveAreaLinkAge = true
        // 默认数据provinceCode cityCode countyCode如果一致 可以不传
        if (_arr[0].key) {
          const obj = {}
          _arr[0].key.forEach((key) => {
            obj[key] = ''
          })
          this.areaCodes = obj
        }
      }
    },
    // 设置当前form禁止输入
    // eslint-disable-next-line vue/no-unused-properties
    setDisabled() {
      this.disabled = true
      // 如果是图片类型则隐藏删除按钮
      this.columns.forEach((item) => {
        if (item.type === 'upload') {
          if (item.options) {
            item.options.showDeleteIcon = false
          }
        }
      })
    },
    // customInput自定义时间
    customInputHandle(el, item) {
      let val = el
      if (item.options) {
        const presetList = ['A1', 'A']
        const preset = item.options.customInputPreset
          ? item.options.customInputPreset.toUpperCase()
          : ''
        if (preset && presetList.includes(preset)) {
          switch (preset) {
            case 'A1':
              val = val.replace(/[^0-9a-zA-Z]/g, '')
              break
            case 'A':
              val = val.replace(/[^a-zA-Z]/g, '')
              break
          }
        } else if (item.options.oninput && (typeof item.options.oninput).toUpperCase() === 'FUNCTION') {
          val = item.options.oninput()
        }
      }
      this.formInline[item.key] = val
    },

    // 重新校验表单单独项
    // eslint-disable-next-line vue/no-unused-properties
    validateFieldKeys(keys) {
      this.$nextTick(() => {
        this.$refs.commonForm.validateField(keys)
      })
    },

    // 重置表单某一项
    // eslint-disable-next-line vue/no-unused-properties
    resetItem(key) {
      this.$refs[key][0].resetField()
    },

    // 取消对表单某一项的校验
    // eslint-disable-next-line vue/no-unused-properties
    clearValidateItem(key) {
      this.$refs[key][0].clearValidate()
    },
  },
  created() {
    // 初始化区域级联组件的默认key值生成对应的对象
    this.initAreaLinkAgeDataByKey()
    this.initParams()
  },
}
</script>

<style lang="scss" scoped>
.search-box {
  margin-bottom: 16px;
  padding: 16px 16px 0;

  .item-bottom-txt {
    font-size: 12px;
  }

  ::v-deep .column-box {
    .el-form-item__content {
      .el-input,
      .el-select,
      .el-textarea,
      .el-date-editor {
        width: 216px;
      }
    }
    .el-form-item {
      // 这是后面添加东西时所需要的
      &.zflex .el-form-item__content {
        display: flex;
      }
      margin-right: 0 !important;
    }
  }

  .column-box > .area-box {
    margin-bottom: 0;
  }
}
::v-deep .el-form-item__label {
  margin-right: 5px;
}
</style>
